import produce from 'immer'

const getIndex = (insertionOrderList, insertionOrder) => {
  const index = insertionOrderList.findIndex(
    item => item.id === insertionOrder.id,
  )
  if (index < 0) throw new Error(`Cannot find IO: ${insertionOrder.id}`)
  return index
}

const mutations = {
  SET_LOADING(state, key) {
    state.loading[key] = true
  },
  CLEAR_LOADING(state, key) {
    state.loading[key] = false
  },
  SET_SEARCH_RESULT(state, payload) {
    state.searchResult = payload
  },
  SET_MENU_LIST(state, payload) {
    state.menuList = payload
  },
  UPDATE_IO(state, { insertionOrder }) {
    const insertionOrderList = state.searchResult.items
    const index = getIndex(insertionOrderList, insertionOrder)
    state.searchResult.items = produce(insertionOrderList, draftState => {
      draftState[index] = insertionOrder
    })
  },
  SET_AGENCY_MARGIN_LIST(state, payload) {
    state.agencyMarginList = payload
  },
  SET_SALES_ACCOUNT_LIST(state, payload) {
    state.salesAccountList = payload
  },
  SET_INSERTION_ORDER_BUDGETS(state, payload) {
    state.insertionOrderBudgets = payload
  },
  SET_INVENTORY_LISTS(state, payload) {
    state.inventoryLists = payload
  },
  SET_KEYWORD(state, keyword) {
    state.keyword = keyword
  },
  SET_ADVERTISER_ID(state, advertiserId) {
    state.advertiserId = Number(advertiserId)
  },
  SET_PAGE_NO(state, pageNo) {
    state.pageNo = Number(pageNo)
  },
  SET_STATUSES(state, ioStatuses) {
    state.ioStatuses = ioStatuses
  },
  UPDATE_SORT_OPTIONS(state, { sortBy, descending }) {
    state.sortOptions.sortBy = sortBy
    state.sortOptions.descending = descending
  },
}

export default mutations
